import { createAuthStore } from "@kontextwerk/web-common";

const store = createAuthStore({
  tokenKey: "kw.cost.bearer",
});

export const getToken = store.getToken;
export const setToken = store.setToken;
export const clearToken = store.clearToken;
